module.exports = __webpack_public_path__ + "static/media/carousel-2.a6e26a58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-2.jpg
// module id = 153
// module chunks = 1